import React from "react";
import { pluginFactories } from "@react-page/plugins-slate";

export default pluginFactories.createComponentPlugin({
  Component: (props) => {
    const focused = props.useFocused();
    const selected = props.useSelected();

    const showSource = focused && selected;

    return (
      <span style={!showSource ? { position: "relative" } : {}}>
        <span
          style={
            showSource
              ? {
                  border: "1px solid",
                  backgroundColor: "white",
                  padding: 12,
                }
              : {
                  opacity: "0",
                  position: "absolute",
                  left: 0,
                  top: 0,
                }
          }
        >
          {props.children}
        </span>
      </span>
    );
  },
  addHoverButton: true,
  addToolbarButton: true,
  type: "Katex",
  object: "inline",
  addExtraSpace: true,
  icon: <span>Σ</span>, // or add a fancy icon
  label: "Katex",
});
